export default "__VITE_ASSET__13FJWGYK__"